module.exports = __webpack_public_path__ + "static/media/rettungskräfte-training.4878ca4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/rettungskräfte-training.svg
// module id = 908
// module chunks = 0